import React from "react";
import { useSelector } from "react-redux";
import LogoutFromTnAccountContainer from "../../../../auth/LogoutFromTnAccount";
import { HEADER_ITEM_IDS } from "../../../../constants/HeaderItemIds";
import backImg from "../../../header/img/backward.png";
import logoutImg from "../../../header/img/logout.png";
import noProfileImg from "../../../header/img/no-profile-photo.png";
import { getLanguageFromUrl } from "../../../../helpers/util";

export const HeaderProfilePopupContent = ({ item, hideSubmenu }) => {
  const user = useSelector(state => state.session.user);
  const language = getLanguageFromUrl()
  const labels = require(`../../../../trans/${language}.json`)

  // format name
  let name = '';
  if (user) {
    name = `${user.firstName} ${user.lastName}`;
  }
  name = name.trim().length > 0 ? name : labels.welcome;
  // format email
  let email = user ? user.email : '';
  email = email.trim().length > 0 ? email : '';

  const settingsItem = item.items.find((item) => item.id === HEADER_ITEM_IDS.SETTINGS);
  const logoutItem = item.items.find((item) => item.id === HEADER_ITEM_IDS.LOGOUT);

  return (
    <>
      <div className="yettel-profile-menu__header">
        <div className='text-left m-4 yettel-profile-menu__header__back-arrow' onClick={ () => {hideSubmenu(); }}>
          <img src={backImg} width={10} alt='back' />
          <span className="yettel-link pr-0 pl-2 yettel-font text-14">{labels.back}</span>
        </div>
        <div className="yettel-profile-menu__header__avatar">
          <img src={noProfileImg} alt="avatar" className="yettel-profile-menu__avatar"/>
        </div>
      </div>
      <div className="yettel-profile-menu__body yettel-font">
        <p className="yettel-profile-menu__body__name ">
          {name}
        </p>
        <p className="yettel-profile-menu__body__email">
          {email}
        </p>
      </div>
      <div className="yettel-profile-menu__items yettel-font">
        <a href={settingsItem.url} className="yettel-profile-menu__items__settings yettel-link-no-underline">
          {settingsItem.title}
        </a>
        <span className="yettel-profile-menu__items__logout yettel-link-no-underline">
          <LogoutFromTnAccountContainer>
            <>
              <img src={logoutImg} alt="logout"/>
              {logoutItem.title}
            </>
          </LogoutFromTnAccountContainer>
        </span>
      </div>
    </>
  );
};

export default HeaderProfilePopupContent;
